<app-label class="context-label" [label]="label">  
    <!-- node actions -->
    <div *ngIf="node" class="context-label__actions" label-actions>
      <ng-content></ng-content>
      <app-node-actions
        *ngIf="enableActions"
        [node]="node"
        theme="light">
      </app-node-actions>
    </div>

    <ng-container *ngIf="enableInfo" label-more>
      <a
        @show
        *ngIf="node.description"
        class="context-label__more"
        (click)="handleReadMoreClick()">Read More...</a>
    </ng-container>
</app-label>